export const filterResources = (
  resources: PerformanceResourceTiming[],
  onlySameOrigin: boolean,
  origin: string,
  pathPrefixes: string[],
) => {
  return resources.filter(({ initiatorType, name }) => {
    const isInitiatorScript = initiatorType === 'script'
    const isJsFile = /\.js(\?|$)/i.test(name)

    if (!isInitiatorScript || !isJsFile) {
      return false
    }

    let url: URL
    try {
      url = new URL(name, window.location.href)
    } catch {
      return false
    }

    if (onlySameOrigin && url.origin !== origin) {
      return false
    }

    if (pathPrefixes.length > 0) {
      return pathPrefixes.some((p) => url.pathname.startsWith(p))
    }

    return true
  })
}
